<template>
  <div>
    <h2 class="text-h5 text-center mb-6">
      {{ title }}
    </h2>
    <div v-if="showNoResults">No results found.</div>
    <div class="scrollable" v-if="!showNoResults">
      <ChartSelector
        v-for="chart in CHART_CONFIGS[chartType]"
        :key="chartType + chart.title"
        :chart-config="CHART_CONFIGS[chartType]"
        :charts-data="chartsData"
        :search-params="searchParams"
        :default-selected="chart"
      />
    </div>
  </div>
</template>

<script>
import lodashIsEmpty from "lodash/isEmpty";

import { MODULE_PREFIX_SEARCH } from "@/store";
import { mapGetters } from "vuex";
import { CHART_CONFIGS } from "@/common/constants/charts";

export default {
  name: "ChartsDisplay",
  components: {
    ChartSelector: () => import("@/components/common/charts/ChartSelector"),
  },
  data: function () {
    return {
      CHART_CONFIGS,
    };
  },
  computed: {
    title() {
      switch (this.chartType) {
        case "security":
          return "Verified Security Event Trends";
        case "maritime":
          return "Verified Maritime Event Trends";
        default:
          return "Event Trends";
      }
    },
    ...mapGetters({
      details: MODULE_PREFIX_SEARCH + "charts",
    }),
    chartType() {
      return this.details.type;
    },
    chartsData() {
      return this.details.data;
    },
    searchParams() {
      return this.details.searchParams;
    },
    showNoResults() {
      return lodashIsEmpty(this.details.data);
    },
  },
};
</script>

<style>
.scrollable {
  height: calc(100vh - 50px); /* 50px for header */
  overflow-y: auto;
  overflow-x: hidden;
  padding-bottom: 60px;
}
</style>
